import { render } from "./CustomLink.vue?vue&type=template&id=0c4cbb7b&scoped=true&ts=true"
import script from "./CustomLink.vue?vue&type=script&lang=ts"
export * from "./CustomLink.vue?vue&type=script&lang=ts"

import "./CustomLink.scss?vue&type=style&index=0&id=0c4cbb7b&scoped=true&lang=scss"

import exportComponent from "/var/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c4cbb7b"]])

export default __exports__